import { FC, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { copy } from 'copy-anything'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import findTicketFormStore from 'entities/ticket/models/find-ticket/find-ticket-store'

import { simpleIsEqual } from 'shared/lib/simpleIsEqual'
import { Carrier } from 'shared/models/ticket'

import { FilterCarrierUi } from './ui/filter-carrier-ui'

import s from './styles.module.scss'

interface Props {}

export interface CarrierSelect extends Carrier {
  selected?: boolean
}

const AirlinesFilter: FC<Props> = observer(() => {
  const navigate = useNavigate()

  const carriers = findTicketFormStore?.dataForFilter?.airlines

  const selected = findTicketFormStore?.formFindTicket?.filter?.airlines?.map(
    (carrier) => carrier.code,
  )

  const initialState = carriers?.map((carrier) => ({
    ...carrier,
    selected: selected?.includes(carrier?.code),
  }))

  const [state, setState] = useState<CarrierSelect[] | undefined>(initialState)

  const onApply = () => {
    const copyForm = copy(findTicketFormStore.formFindTicket?.filter) || {}
    const copyState = state?.filter((carrier) => carrier.selected)

    copyForm.airlines = copyState

    findTicketFormStore.onSetFilter(copyForm)

    navigate(RoutingPaths.avia.search.path())
  }

  const onReset = () => {
    const resetValue = state?.map((item) => ({ ...item, selected: false }))

    setState(resetValue)
  }

  const onBack = () => {
    navigate(-1)
  }

  const onSelectCarrier = (index: number) => {
    const copyState = copy(state)

    if (copyState?.length) {
      copyState[index] = {
        ...copyState[index],
        selected: !copyState[index]?.selected,
      }
    }

    setState(copyState)
  }

  const isNotSame = simpleIsEqual(initialState, state)
  const canDisabled = state?.some((air) => air.selected)
  return (
    <div className={clsx('container', s.container)}>
      <FilterCarrierUi
        state={state}
        titleKey="airlines"
        isSameFilter={isNotSame}
        canDisabled={canDisabled}
        onBack={onBack}
        onApply={onApply}
        onReset={onReset}
        onSelect={onSelectCarrier}
      />
    </div>
  )
})

export default AirlinesFilter
